import React from "react";
import { Formik } from "formik";
import Grid from "@material-ui/core/Grid";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import { MaterialSelect } from "../components/select-field.component";
import { Api } from "../utils/api";
import { MaterialSelectFormik } from "../user_requests/components/select-field.component";

const optionsToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};

export const socialWorkerOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/admins", { admin_group_ids: [5], active: true })
    .then((res) => res.data)
    .then((res) => {
      res.push({ id: 0, name: "Todas as consultoras" });
      return res;
    })
    .then(optionsToSelect);
};

//atençao que aqui ele passa o id do establishments_valences e nao do establishments
//só mostra equipamentos de valencia 2 e activos
export const establishmentValenceOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/establishments", { input_filter_establishments: true })
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const VisitsFilterForm = ({ searchVisits, administrator }) => (
  <div>
    {(administrator === true || administrator === false) && (
      <Formik
        initialValues={{
          social_worker: "",
          establishment_valence: "",
          since: moment().format("YYYY-MM-DD"),
          until: moment().format("YYYY-MM-DD"),
          filter_type: "visit_time",
        }}
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            JSON.stringify(values, null, 2);
            console.log(values);
            searchVisits(
              values.social_worker,
              values.establishment_valence,
              moment(values.since).format("YYYY-MM-DD"),
              moment(values.until).add(1, "day").format("YYYY-MM-DD"),
              values.filter_type
            );
            setSubmitting(false);
          }, 400);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          handleInputChange,
        }) => (
          <Grid item md={12}>
            <form onSubmit={handleSubmit}>
              {administrator === true && (
                <Grid item md={5}>
                  <MaterialSelect
                    name="social_worker"
                    label="Consultor(a)"
                    onBlur={setFieldTouched}
                    onChange={setFieldValue}
                    optionsFetcher={socialWorkerOptionsPromise}
                    value={values.social_worker}
                  />
                </Grid>
              )}

              <Grid item md={5} className="mt-3">
                <MaterialSelectFormik
                  name="establishment_valence"
                  placeholder="establishment_valence"
                  label="Equipamentos"
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  defaultValue={""}
                  limit={10}
                  value={values.establishment_valence}
                  optionsFetcher={establishmentValenceOptionsPromise}
                />
              </Grid>
              <h6 class="mt-4">Filtrar por</h6>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="filterType1"
                  name="filter_type"
                  value="visit_time"
                  onChange={handleChange}
                  checked={values.filter_type == "visit_time"}
                />
                <label class="form-check-label" for="filterType1">
                  Data da visita
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="filterType2"
                  name="filter_type"
                  value="visit_time_update"
                  onChange={handleChange}
                  checked={values.filter_type == "visit_time_update"}
                />
                <label class="form-check-label" for="filterType2">
                  Data de registo da visita
                </label>
              </div>

              <div class="form-inline form-group mt-4 mb-4">
                <span class="pt-2 pb-2 pr-2">Desde:</span>
                <input
                  class="form-control mb-1 p-2"
                  name="since"
                  type="date"
                  required
                  margin="normal"
                  onChange={handleChange}
                  component={DatePicker}
                  value={values.since}
                />
                <span class="p-2">até</span>
                <input
                  class="form-control mb-1 p-2"
                  name="until"
                  type="date"
                  required
                  margin="normal"
                  onChange={handleChange}
                  component={DatePicker}
                  value={values.until}
                />
              </div>

              <div>
                <button
                  type="submit"
                  class="btn btn-primary"
                  disabled={isSubmitting}
                >
                  Filtrar
                </button>
              </div>
            </form>
          </Grid>
        )}
      </Formik>
    )}
  </div>
);
